import { createSelector } from '@reduxjs/toolkit';
import { pickBy } from 'lodash';

import isValidSbatGroupFilter from '@classCreation/utils/isValidSbatGroupFilter';

const baseSelector = (state) => state.sbatGroupBulkUpdateFilter;

export const sbatGroupBulkUpdateFilterSelector = baseSelector;

export const isSbatGroupBulkUpdateFilterModalOpenSelector = createSelector(
  (state) => baseSelector(state).isModalOpen,
  (isModalOpen) => isModalOpen
);

export const appliedFiltersSelector = createSelector(
  (state) => baseSelector(state).primaryInstructors.applied,
  (state) => baseSelector(state).secondaryInstructors.applied,
  (state) => baseSelector(state).academyModules.applied,
  (state) => baseSelector(state).academyTopics.applied,
  (state) => baseSelector(state).superBatches.applied,
  (state) => baseSelector(state).fromDate.applied,
  (state) => baseSelector(state).toDate.applied,
  (
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    academyTopics,
    superBatches,
    fromDate,
    toDate
  ) => ({
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    academyTopics,
    superBatches,
    fromDate,
    toDate,
  })
);

export const currentFiltersSelector = createSelector(
  (state) => baseSelector(state).primaryInstructors.current,
  (state) => baseSelector(state).secondaryInstructors.current,
  (state) => baseSelector(state).academyModules.current,
  (state) => baseSelector(state).academyTopics.current,
  (state) => baseSelector(state).superBatches.current,
  (state) => baseSelector(state).fromDate.current,
  (state) => baseSelector(state).toDate.current,
  (
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    academyTopics,
    superBatches,
    fromDate,
    toDate
  ) => ({
    primaryInstructors,
    secondaryInstructors,
    academyModules,
    academyTopics,
    superBatches,
    fromDate,
    toDate,
  })
);

export const areAppliedFiltersPresentSelector = createSelector(
  appliedFiltersSelector,
  (appliedFilters) => {
    const filters = pickBy(appliedFilters, isValidSbatGroupFilter);
    return Object.keys(filters).length > 0;
  }
);

export const areCurrentFiltersPresentSelector = createSelector(
  currentFiltersSelector,
  (currentFilters) => {
    const filters = pickBy(currentFilters, isValidSbatGroupFilter);
    return Object.keys(filters).length > 0;
  }
);
